import React, { ReactElement, useState } from 'react';
import { Box, Button, HStack, Slider, Text, VStack } from '@chakra-ui/react';
import { getBlockValue } from 'utils/blockMigrationUtils';
import { useWorksheetSession } from 'contexts/WorksheetSessionContext';
import { SABlockProps } from '../SelfAssessmentBlock';

type Props = SABlockProps;

export const StudentSABlock = ({ block, editor }: Props): ReactElement => {
  const [score, setScore] = useState<number>(Math.max(block.props.score, block.props.minScore));
  const [shouldShowResults, setShouldShowResults] = useState<boolean>(block.props.isSubmitted);
  const worksheetSession = useWorksheetSession();

  const updateOptions = (): void => {
    editor.updateBlock(block, {
      props: {
        score,
        isSubmitted: true,
      },
    });
    setShouldShowResults(true);
    // Only auto-save if in student session context (has provider)
    if (worksheetSession?.onBlockSubmit) {
      worksheetSession.onBlockSubmit(editor.document);
    }
  };

  return (
    <VStack
      border="default"
      borderColor="border.accent"
      borderRadius="l"
      p="l"
      gap="l"
      width="100%"
      alignItems="flex-start"
      contentEditable={false}
    >
      <Text textStyle={{ base: 'body.m.medium', md: 'h4.medium' }} color="text.primary">
        {getBlockValue(block, 'question')}
      </Text>

      <HStack maxWidth="500px" width="100%" gap="15px">
        <Slider.Root
          defaultValue={[block.props.minScore]}
          min={block.props.minScore}
          max={block.props.maxScore}
          step={1}
          onValueChange={(details) => setScore(details.value[0])}
          disabled={shouldShowResults}
          colorScheme="green"
          flexGrow={1}
          value={[score === -1 ? block.props.minScore : score]}
        >
          <Slider.Control>
            <Slider.Track height="5px" backgroundColor="border.accent">
              <Slider.Range backgroundColor="background.accent" />
            </Slider.Track>
            <Slider.Thumb
              index={0}
              boxSize="22px"
              backgroundColor="background.accent !important"
              borderRadius="100%"
              border="4px solid"
              borderColor="grey.white"
              shadow="0px 0px 0px 1px #3EA37E !important"
              _grabbed={{
                shadow: '0px 0px 0px 1px #3EA37E !important',
              }}
              _active={{
                shadow: '0px 0px 0px 1px #3EA37E !important',
              }}
            >
              <Slider.HiddenInput />
            </Slider.Thumb>
          </Slider.Control>
        </Slider.Root>
        <Box
          borderRadius="5px"
          backgroundColor="background.canvas"
          display="grid"
          placeItems="center"
          width="30px"
          height="25px"
          border="default"
          borderColor="border.accent"
        >
          <Text textStyle="body.m.regular" color="text.primary" lineHeight="16px">
            {score}
          </Text>
        </Box>
      </HStack>
      {shouldShowResults ? (
        <Text textStyle="body.m.regular" color="text.quaternary">
          Antwort gespeichert!
        </Text>
      ) : (
        <Button
          type="submit"
          variant="primary"
          onClick={updateOptions}
          disabled={shouldShowResults}
        >
          Abschicken
        </Button>
      )}
    </VStack>
  );
};
